import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    edit: translate({ id: 'setup.driverAssistance.view.edit' }),
    copy: translate({ id: 'setup.driverAssistance.view.copy' }),
    copySettings: translate({ id: 'setup.driverAssistance.view.copySettings' }),
    oneTerritory: translate({ id: 'setup.driverAssistance.view.oneTerritory' }),
    modeHeader: translate({ id: 'setup.driverAssistance.view.modeHeader' }),
    title: translate({ id: 'setup.DriverAssistance.view.title' }),
    description: translate({ id: 'setup.driverAssistance.view.description' }),
    learnMore: translate({ id: 'setup.driverAssistance.learnMore' }),
  }))

  return api
}
